export default {
  DIALOG_END: 'DIALOG_END',
  TRANSFERRED: 'TRANSFERRED',
  AGENT_JOINED: 'AGENT_JOINED',
  TRANSFERRED_DISABLE_INPUT: 'TRANSFERRED_DISABLE_INPUT',
  AGENT_LEFT: 'AGENT_LEFT',
  SESSION_EXPIRED: 'SESSION_EXPIRED',
};
